import React, { useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  TextInput,
  FlatList,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import BackArrow from "../../assets/svg/BackArrow";
import SearchIcon from "../../assets/svg/SearchIcon";
import color from "../../constants/color";
import { NavKey, CrateType } from "./types";
import { useSelector } from "react-redux";
import { selectReturnCratesList } from "../../selectors/returns.selector";
import t from "@constants/localization";
import HandoverVideoStrip from "@screens/MyDeliveries/DeliveryReturn/HandoverVideoStrip";

const PATH = "screens/Returns";

interface ReturnCrateDetails {
  route: {
    params: {
      navKey: NavKey;
      crateType: CrateType;
    };
  };
}

const ReturnCrateDetails = ({ route }: ReturnCrateDetails) => {
  const { navKey, crateType } = route.params;
  const navigation = useNavigation();
  const data: string[] = useSelector((state: any) =>
    selectReturnCratesList(state, navKey, crateType)
  );

  const [searchQuery, setSearchQuery] = useState("");

  const renderItem = ({ item, index }: { item: string; index: number }) => (
    <View
      style={[
        styles.card,
        index === 0 && styles.firstCard,
        index === data.length - 1 && styles.lastCard,
      ]}
    >
      <Text>{item}</Text>
    </View>
  );

  const filteredData = data.filter((crate: string) =>
    crate.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <BackArrow />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>{t(`${PATH}/CRATES_${navKey}`)}</Text>
      </View>
      <HandoverVideoStrip />
      <View style={styles.searchBar}>
        <SearchIcon style={styles.searchIcon} />
        <TextInput
          placeholder={t(`${PATH}/crateSearchPlaceholder`)}
          style={styles.searchInput}
          value={searchQuery}
          onChangeText={(text) => setSearchQuery(text)}
        />
      </View>
      <FlatList
        data={filteredData}
        keyExtractor={(item, index) => item + index}
        renderItem={renderItem}
        contentContainerStyle={styles.listContent}
        getItemLayout={(_, index) => ({
          length: 40,
          offset: 40 * index,
          index,
        })}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.darkBackground,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 16,
    backgroundColor: color.white,
  },
  headerTitle: {
    flex: 1,
    fontSize: 18,
    fontWeight: "bold",
    marginLeft: 16,
  },
  searchBar: {
    flexDirection: "row",
    alignItems: "center",
    margin: 16,
    marginBottom: 0,
    paddingHorizontal: 16,
    borderRadius: 20,
    backgroundColor: color.white,
    borderWidth: 1,
    borderColor: color.blank_grey,
    height: 40,
  },
  searchIcon: {
    marginRight: 8,
  },
  searchInput: {
    flex: 1,
    fontSize: 12,
    fontWeight: "400",
    height: 40,
  },
  listContent: {
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  sectionHeader: {
    fontSize: 16,
    fontWeight: "500",
    paddingVertical: 8,
  },
  card: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    backgroundColor: color.white,
    height: 40,
  },
  firstCard: {
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8,
  },
  lastCard: {
    borderBottomRightRadius: 8,
    borderBottomLeftRadius: 8,
  },
});

export default ReturnCrateDetails;
